import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';
import { API_BASE_PATH } from './constants';

interface AgentFirmCompany {
  id: number;
  name: string;
}

interface UseAgentFirmCompaniesResponse {
  data: AgentFirmCompany[];
}

type UseAgentFirmCompaniesOptions = {
  agentFirmId?: string;
  enabled?: boolean;
};

export function useAgentFirmCompanies(options: UseAgentFirmCompaniesOptions) {
  const { agentFirmId, enabled = true } = options;

  const url = agentFirmId
    ? `${API_BASE_PATH}/agentFirm/${agentFirmId}/companies`
    : null;

  const { data, error, isLoading } = useSWR<UseAgentFirmCompaniesResponse>(
    enabled && url ? url : null,
    SWRFetcher({ method: 'GET' })
  );

  return {
    data: data?.data ?? [],
    error,
    isLoading,
  };
}
